import { wizardError, wizardRequest, wizardSkipError, wizardSkipRequest, wizardSkipSuccess, wizardSuccess } from '@store/slices/wizard/wizardSlice.js';
import httpClient from '@utils/httpClient.js';
import { call, put, takeLatest } from 'redux-saga/effects';

function getWizardApiCall({ step, wizard_id, ig_user_id, username, type, data, is_shop, is_email, theme_id }) {
  let body = {};

  switch (step) {
    case 2:
      body = {
        wizard_id,
        ig_user_id,
        username,
      };
      break;
    case 3:
      body = {
        wizard_id,
        ig_user_id,
        type,
        data,
      };
      break;
    case 4:
      body = {
        wizard_id,
        ig_user_id,
        is_shop,
      };
      break;
    case 5:
      body = {
        wizard_id,
        ig_user_id,
        is_email,
      };
      break;
    case 6:
      body = {
        wizard_id,
        ig_user_id,
        theme_id,
      };
      break;
  }

  return httpClient.post(`api/wizard/${step}`, body);
}

function getWizardSkipApiCall(payload) {
  return httpClient.post(`api/wizard/skip`, payload);
}

function* wizardSaga({ payload }) {
  try {
    const { step } = payload;
    const { data } = yield call(getWizardApiCall, payload);

    yield put(wizardSuccess({ step, data }));
  } catch (error) {
    yield put(wizardError(error.message ? error.message : error.toString()));
  }
}

function* wizardSkipSaga({ payload }) {
  try {
    const { step } = payload;
    const { data } = yield call(getWizardSkipApiCall, payload);

    yield put(wizardSkipSuccess({ step, data }));
  } catch (error) {
    yield put(wizardSkipError(error.message ? error.message : error.toString()));
  }
}

export function* wizardSkipWatcher() {
  yield takeLatest(wizardSkipRequest, wizardSkipSaga);
}

export function* wizardWatcher() {
  yield takeLatest(wizardRequest, wizardSaga);
}
